import { useState, useEffect } from 'react';

const defaultSettings = {
  enableHighAccuracy: false,
  timeout: Infinity,
  maximumAge: 0
};

const DEFAULT_ERROR_MESSAGE = 'Geolocation is not supported';

const usePosition = (watch = false, settings = defaultSettings) => {
  const [position, setPosition] = useState({});
  const [error, setErrorMessage] = useState(null);

  const onChange = ({ coords, timestamp }) => {
    setPosition({
      latitude: coords.latitude,
      longitude: coords.longitude,
      accuracy: coords.accuracy,
      timestamp
    });
  };

  const onError = (e) => {
    setErrorMessage(e.message);
    setPosition({
      latitude: null,
      longitude: null
    });
  };

  useEffect(() => {
    // eslint-disable-next-line no-undef
    const geo = navigator.geolocation;
    if (!geo) {
      setErrorMessage(DEFAULT_ERROR_MESSAGE);
      return;
    }

    let watcher = null;
    if (watch) {
      watcher = geo.watchPosition(onChange, onError, settings);
    } else {
      geo.getCurrentPosition(onChange, onError, settings);
    }

    // eslint-disable-next-line consistent-return
    return () => watcher && geo.clearWatch(watcher);
  }, [settings, watch]);

  return { ...position, error };
};

export default usePosition;
